export { default } from './Text';
export type { Props } from './Text';



// WEBPACK FOOTER //
// ../kibble/components/Text/index.ts